import React from 'react';

/**
 * Anti-bot honeypot: leave empty for humans; naive bots often fill hidden fields.
 * Parent must keep `formHp` state and send `form_hp: formHp` in the JSON body.
 */
export default function FormHoneypot({ value, onChange }) {
  return (
    <input
      type="text"
      name="form_hp"
      tabIndex={-1}
      autoComplete="off"
      aria-hidden="true"
      value={value}
      onChange={(e) => onChange(e.target.value)}
      style={{
        position: 'absolute',
        left: '-10000px',
        width: 1,
        height: 1,
        overflow: 'hidden',
      }}
    />
  );
}
